var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.412,
    height: 13.948,
    viewBox: "0 0 33.412 13.948",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "arrow-right",
    d: "M-6.3,40.948l.985-.985a1.061,1.061,0,0,1,1.5,0L2.1,45.869a1.061,1.061,0,0,1,0,1.5l-5.911,5.911a1.061,1.061,0,0,1-1.5,0L-6.3,52.3a1.066,1.066,0,0,1,.018-1.522L-3.653,48.4H-29.935A1.063,1.063,0,0,1-31,47.334v-1.42a1.063,1.063,0,0,1,1.065-1.065H-3.653l-2.631-2.378A1.059,1.059,0,0,1-6.3,40.948Z",
    transform: "translate(31 -39.65)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIcon);
export default __webpack_public_path__ + "static/media/arrow_icon.a9658b7414637e205667527dc56ab181.svg";
export { ForwardRef as ReactComponent };